import React, { PureComponent }         from 'react'
import './index.less'
export default class Loading extends PureComponent{
    render() {
        const { text} = this.props
        return (
            <div className="loading-mask">
                <div className="loading">
                    <div className="loading-icon"></div>
                    <p>{text||'马上就加载好啦'}</p>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Loading/index.js